module.exports = {"TITLE":"TFS Instore","LANGUAGE":"nl","BRAND":"TFS","PAGE_AUTO_RELOAD":{"PACKAGE_ORDER_LIST":{"active":false,"ms":60000},"TRANSFER_ORDER_LIST":{"active":true,"ms":60000}},"HAS_SMS_VERIFICATION_FOR_REGISTER":false,"HAS_SMS_VERIFICATION_FOR_LOGIN":false,"ANTD_LOCALE":"nl","HAS_PERMISSION_FOR_PAGES":false,"SESSION_EXPIRED_MINUTES":1440}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/app.json
// module id = 21
// module chunks = 1